// extracted by mini-css-extract-plugin
module.exports = {"footerContainer":"ClientWallet_footerContainer__11Rt-","savePackageButton":"ClientWallet_savePackageButton__7JOka"};